
export default function TechnicalProjectsSection() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-[#5C1A24] rounded-full flex items-center justify-center mr-4">
                <i className="ri-settings-3-line text-white text-xl"></i>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-[#5C1A24]" style={{ fontFamily: '"Playfair Display", serif' }}>
                Projetos Elétricos e Complementares
              </h2>
            </div>
            
            <div className="text-[#3F3F3F] leading-relaxed space-y-4">
              <p>
                Por trás de cada ambiente perfeito, há um projeto técnico preciso.
              </p>
              <p>
                Cuidamos de instalações elétricas, hidráulicas, estruturais e de prevenção, garantindo segurança, eficiência e economia.
              </p>
              <p className="font-medium text-[#5C1A24]">
                Desenvolvemos projetos integrados, evitando conflitos e assegurando que tudo funcione exatamente como planejado.
              </p>
            </div>

            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {[
                'Instalações elétricas',
                'Projetos hidráulicos',
                'Estruturas seguras',
                'Prevenção contra incêndio'
              ].map((feature, index) => (
                <div key={index} className="flex items-center">
                  <i className="ri-check-line text-[#5C1A24] mr-2"></i>
                  <span className="text-sm text-[#3F3F3F]">{feature}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div>
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/c19c87330650c37fad85eaa57e1feb07.jpeg"
                alt="Projetos Elétricos e Complementares"
                className="w-full h-80 object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#5C1A24]/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
